import React from 'react'
import { UpdateItem } from './types'
import moment from 'moment'

interface Props {
  updates: UpdateItem[]
}

const UpdateListItem: React.FunctionComponent<{ update: UpdateItem }> = ({
  update,
}) => {
  const formattedDate = moment(update.date).format('dddd, MMMM Do')

  return (
    <li className='blog-list_item'>
      <div className='blog-list_date'>{formattedDate}</div>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href={update.url} target='_blank' className='blog-list_link'>
        {update.title}
      </a>
    </li>
  )
}

export const UpdateList: React.FunctionComponent<Props> = props => {
  const { updates } = props

  return (
    <ul className='blog-list'>
      {updates.map((update, index) => (
        <UpdateListItem update={update} key={index} />
      ))}
    </ul>
  )
}
